'use client';

import axios from 'axios';

const BACKEND_TOKEN_KEY = 'auth.backendToken';

function isNativeRuntime() {
    return typeof window !== 'undefined' && Boolean(window.Capacitor?.isNativePlatform?.());
}

async function getNativeSecureStorage() {
    if (!isNativeRuntime()) return null;

    const { SecureStorage } = await import('@aparajita/capacitor-secure-storage');
    return { plugin: SecureStorage };
}

function setAxiosAuthHeader(token) {
    if (!token) return;
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.defaults.headers.common['Content-Type'] = 'application/json';
}

export async function saveBackendTokenToSecureStorage(token) {
    if (!token || typeof token !== 'string') return;

    try {
        const secureStorage = (await getNativeSecureStorage())?.plugin;
        if (secureStorage) {
            await secureStorage.set(BACKEND_TOKEN_KEY, token);
            return;
        }

        if (typeof window !== 'undefined') {
            window.localStorage.setItem(BACKEND_TOKEN_KEY, token);
        }
    } catch (error) {
        console.warn('Secure token save failed', error);
    }
}

export async function readBackendTokenFromSecureStorage() {
    try {
        const secureStorage = (await getNativeSecureStorage())?.plugin;
        if (secureStorage) {
            const value = await secureStorage.get(BACKEND_TOKEN_KEY);
            return typeof value === 'string' && value ? value : null;
        }

        if (typeof window !== 'undefined') {
            return window.localStorage.getItem(BACKEND_TOKEN_KEY);
        }
    } catch (error) {
        console.warn('Secure token read failed', error);
    }

    return null;
}

export async function clearBackendTokenFromSecureStorage() {
    try {
        const secureStorage = (await getNativeSecureStorage())?.plugin;
        if (secureStorage) {
            await secureStorage.remove(BACKEND_TOKEN_KEY);
            return;
        }

        if (typeof window !== 'undefined') {
            window.localStorage.removeItem(BACKEND_TOKEN_KEY);
        }
    } catch (error) {
        console.warn('Secure token clear failed', error);
    }
}

export async function restoreAxiosAuthFromSecureStorage() {
    if (typeof window === 'undefined') return null;
    if (axios?.defaults?.headers?.common?.Authorization) {
        return axios.defaults.headers.common.Authorization;
    }

    const token = await readBackendTokenFromSecureStorage();
    if (token) {
        setAxiosAuthHeader(token);
    }

    return token;
}
